import { useSelector } from 'react-redux';

import { ComponentLoader } from 'components';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import { urls } from 'features/common/fetch/constants';
import { LEAD_ALREADY_TAKEN, quickFilter } from 'features/views/marketPlace/constants';
import { getQuickFilterState } from 'features/views/marketPlace/selectors';

import TableInProgressAndAfterDeadline from './TableInProgressAndAfterDeadline';
import TableQuickFilters from './TableQuickFilters';

const MarketPlaceTable = () => {
	const quickFilterState = useSelector(getQuickFilterState);

	const ignoreErrorsForTakeLead = useIgnoreErrorsWhen({
		fetchStorePath: urls.takeLead,
		attributePath: ['metaData', 'parsedContent', 'code'],
		value: LEAD_ALREADY_TAKEN,
	});

	return (
		<ComponentLoader fetchStorePath={urls.takeLead} ignoreErrors={ignoreErrorsForTakeLead}>
			{quickFilterState === quickFilter.INPROGRESSORAFTERDEADLINE ? (
				<TableInProgressAndAfterDeadline />
			) : (
				<TableQuickFilters />
			)}
		</ComponentLoader>
	);
};

export default MarketPlaceTable;
